module.exports = __webpack_public_path__ + "img/logo.e435a317.svg";